import styled from "@emotion/styled";

export const StyledIncomes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
